import PropTypes from 'prop-types';
import React from 'react';

import c from 'classnames';

import chroma from 'chroma-js';
import crc32 from 'lighter-crc32';

function hashRange(num, bitSkip = 0, bitCount = 32) {
	return ((num / Math.pow(2, bitSkip)) & (Math.pow(2, bitCount) - 1))
		/ (Math.pow(2, bitCount) - 1);
}

export default class Tag extends React.Component {
	static propTypes = {
		category: PropTypes.object.isRequired,
		label: PropTypes.string.isRequired,
		longLabel: PropTypes.string,
		parent: PropTypes.object,
	}

	render() {
		const {
			category,
			label,
			longLabel,
			parent,
		} = this.props;

		const categoryHash = crc32('salt-Q' + category.label);
		const categoryChroma = 30 + hashRange(categoryHash, 0, 10) * 20;
		const categoryLightness = 30 + hashRange(categoryHash, 10, 10) * 10;
		const categoryHue = hashRange(categoryHash, 20, 12) * 360;
		const labelHash = crc32('salt-f' + label);
		const labelHueDiff = hashRange(labelHash, 0, 10) * 30;
		const labelLightnessDiff = hashRange(labelHash, 10, 10) * 50;
		const labelChromaDiff = hashRange(labelHash, 20, 12) * 40;

		const categoryColour = chroma.hcl(categoryHue, categoryChroma, categoryLightness);
		const labelColour = chroma.hcl(categoryHue + labelHueDiff, categoryChroma + labelChromaDiff, categoryLightness + labelLightnessDiff);

		return (
			<span className="tag">
				<span
					className={c('tag__label', labelColour.luminance() > 0.18 && 'tag__label--light-bg')}
					title={longLabel}
					style={{
						backgroundColor: labelColour.hex(),
					}}
				>
					{label}
				</span>
			</span>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Tag.js